import React, { useState } from "react";
import classes from "./magazinemanagementheader.module.scss";
import { GiHamburgerMenu } from "react-icons/gi";
import OffcanvasMain from "../Offcanvas";
import SideBar from "../SideBar";
import ModalMain from "../Modal";
import { useTranslation } from "react-i18next";
import AddSupplier from "../../ModalComponents/SupplierManagementModal/AddSupplier";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  actionMagazinesApiCall,
  setperPageMagazineCount,
} from "../../../Redux/Actions";
import { useMemo } from "react";

const MagazineManagementHeader = () => {
  const { t } = useTranslation();
  const state = useSelector((state) => state.CommonReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sidebar, setSideBar] = useState(false);
  const [createBanner, setCreateBanner] = useState(false);
  const [perpage, setPerPage] = useState(
    state?.perPageSupplierCount ? state?.perPageSupplierCount : 40
  );
  const [inputType, setInputType] = useState("text");
  const [inputType1, setInputType1] = useState("text");
  const [name, setName] = useState();

  const filterClick = () => {
    const data = {
      page: 1,
      per_page: perpage,
      supplier_name: name,
    };
    const body = { data, navigate };

    dispatch(actionMagazinesApiCall(body));
  };
  useMemo(() => {
    filterClick();
    dispatch(setperPageMagazineCount(perpage));
  }, [perpage]);

  const handleFocus = () => {
    setInputType("date");
  };
  const handleFocus1 = () => {
    setInputType1("date");
  };
  const handleBlur = () => {
    setInputType("text");
  };
  const handleBlur1 = () => {
    setInputType1("text");
  };
  const sidebarShow = () => {
    setSideBar(true);
  };
  const createBannerShow = () => {
    setCreateBanner(true);
  };

  const handleClose = () => {
    console.log("handle close called");
    setSideBar(false);
    setCreateBanner(false);
  };

  return (
    <React.Fragment>
      <div className={classes.HeaderWrap}>
        <div className={classes.ManagmentSection}>
          <div className={classes.CanvasWarp}>
            <button onClick={sidebarShow}>
              <GiHamburgerMenu />
            </button>
          </div>
          <div className={classes.FilterSection}>
            <h5>{t("magazine_management")}</h5>
            <form>
              <div className={classes.managementFild}>
                <div className={classes.fildBox}>
                  <input
                    type="text"
                    placeholder={`${t("name_p")}...`}
                    onChange={(e) => setName(e.target.value)}
                    className={classes.Text}
                  />
                </div>
                <div
                  className={classes.fildBox}
                  onClick={(e) => {
                    e.preventDefault();
                    filterClick();
                  }}
                >
                  <button>{t("filter")}</button>
                </div>
              </div>
            </form>
          </div>
          <div className={classes.ManagbBnnerSection}>
            <button onClick={createBannerShow}>{t("add_magazine")}</button>
          </div>
        </div>
        <div className={classes.BannersPerPageSection}>
          <p>{t("magazine_per_page")}</p>
          <div className={classes.numberOfUser}>
            <select
              id="page"
              name="page"
              onChange={(e) => setPerPage(e.target.value)}
              defaultValue={perpage}
            >
              <option value={40} key={40}>
                40
              </option>
              <option value={50} key={50}>
                50
              </option>
              <option value={60} key={60}>
                60
              </option>
              <option value={70} key={70}>
                70
              </option>
            </select>
          </div>
        </div>
      </div>
      <OffcanvasMain showcanvas={sidebar} handleClose={handleClose}>
        <SideBar />
      </OffcanvasMain>
      <ModalMain showmodel={createBanner} handleClose={handleClose} size={"md"}>
        <AddSupplier onClose={handleClose} />
      </ModalMain>
    </React.Fragment>
  );
};

export default MagazineManagementHeader;
